import { CircleGaugeIcon, SparklesIcon, LayersIcon, RocketIcon } from 'lucide-react';

import PlanPoster from '@/shared/assets/media/springboard/plan.webp';
import CreatePoster from '@/shared/assets/media/springboard/create.webp';
import ScalePoster from '@/shared/assets/media/springboard/scale.webp';
import DeliverPoster from '@/shared/assets/media/springboard/deliver.webp';
import PlanVideo from '@/shared/assets/media/springboard/plan.mp4';
import CreateVideo from '@/shared/assets/media/springboard/create.mp4';
import ScaleVideo from '@/shared/assets/media/springboard/scale.mp4';
import DeliverVideo from '@/shared/assets/media/springboard/deliver.mp4';
import PlanIcon from '@/shared/assets/images/plan.svg';
import CreateIcon from '@/shared/assets/images/create.svg';
import ScaleIcon from '@/shared/assets/images/scale.svg';
import DeliverIcon from '@/shared/assets/images/deliver.svg';
import { i18n } from '@/shared/i18n';

// Getters, not values: these arrays are built while the module is evaluated, so resolving per
// read is what lets the copy follow a language change instead of freezing at import.
export const SPRINGBOARD_CARDS = [
  {
    id: 'plan',
    get title() {
      return i18n.t('springboard:dashboard.springboardCards.plan');
    },
    get description() {
      return i18n.t('springboard:dashboard.springboardCards.planDescription');
    },
    poster: PlanPoster,
    video: PlanVideo,
    icon: PlanIcon,
  },
  {
    id: 'create',
    get title() {
      return i18n.t('springboard:dashboard.springboardCards.create');
    },
    get description() {
      return i18n.t('springboard:dashboard.springboardCards.createDescription');
    },
    poster: CreatePoster,
    video: CreateVideo,
    icon: CreateIcon,
  },
  {
    id: 'scale',
    get title() {
      return i18n.t('springboard:dashboard.springboardCards.scale');
    },
    get description() {
      return i18n.t('springboard:dashboard.springboardCards.scaleDescription');
    },
    poster: ScalePoster,
    video: ScaleVideo,
    icon: ScaleIcon,
  },
  {
    id: 'deliver',
    get title() {
      return i18n.t('springboard:dashboard.springboardCards.deliver');
    },
    get description() {
      return i18n.t('springboard:dashboard.springboardCards.deliverDescription');
    },
    poster: DeliverPoster,
    video: DeliverVideo,
    icon: DeliverIcon,
  },
] as const;
export const SPRINGBOARD_CARDS_V2 = [
  {
    id: 'plan',
    get title() {
      return i18n.t('springboard:dashboard.springboardCards.plan');
    },
    get description() {
      return i18n.t('springboard:dashboard.springboardCards.planDescription');
    },
    poster: PlanPoster,
    video: PlanVideo,
    icon: CircleGaugeIcon,
  },
  {
    id: 'create',
    get title() {
      return i18n.t('springboard:dashboard.springboardCards.create');
    },
    get description() {
      return i18n.t('springboard:dashboard.springboardCards.createDescription');
    },
    poster: CreatePoster,
    video: CreateVideo,
    icon: SparklesIcon,
  },
  {
    id: 'scale',
    get title() {
      return i18n.t('springboard:dashboard.springboardCards.scale');
    },
    get description() {
      return i18n.t('springboard:dashboard.springboardCards.scaleDescription');
    },
    poster: ScalePoster,
    video: ScaleVideo,
    icon: LayersIcon,
  },
  {
    id: 'deliver',
    get title() {
      return i18n.t('springboard:dashboard.springboardCards.deliver');
    },
    get description() {
      return i18n.t('springboard:dashboard.springboardCards.deliverDescription');
    },
    poster: DeliverPoster,
    video: DeliverVideo,
    icon: RocketIcon,
  },
] as const;
